import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Cover from '../components/cover/cover'
import Layout from "../components/layout"
import SEO from "../components/seo"
import AchievementsCard from "../components/achievement-card/achievement-card"

import { StaticImage } from "gatsby-plugin-image"

import cover from "../images/team-cover-alt.jpg"

const AchievementsPage = () => {

    const data = useStaticQuery(graphql`
    query {
        allContentfulAchievements {
            nodes {
              name
              year
              thumbnail {
                file {
                  url
                }
              }
              description {
                description
              }
            }
          }
        }
    `)
    
    return (
  <Layout>
    <SEO title="We Clothe Them - Achievements" />
    <Cover image={cover} title={`Achievements`} />
    <section className={`dark sm`}>
      <div className={`content`}>
        <h6 className={`letter-spaced-heading center`}>Our Achievements</h6>
        <h2 className={`center`}>What we've done so far</h2>
        <div className={`split-wrapper-alt`}>
          <div className={`split-alt`}>
          <div className={`map-wrapper`}>
            <div className={`map`}>
              <StaticImage src={`../images/Map Main.png`} width={1000} />
            </div>
          </div>
          </div>
          <div className={`split-alt`}>
          <div
            className={`flex margins`}
            style={{ justifyContent: `center`, flexWrap: `wrap` }}
          >
            <div className={`stat-tile`}>
                <h1>2</h1>
                <p>Countries</p>
            </div>
            <div className={`stat-tile`}>
                <h1>4</h1>
                <p>Cities</p>
            </div>
            <div className={`stat-tile`}>
                <h1>50+</h1>
                <p>Drives</p>
            </div>
            <div className={`stat-tile`}>
                <h1>7,000+</h1>
                <p>People Clothed</p>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
    <section className={`sm`}>
      <div className={`content`}>
        <h6 className={`letter-spaced-heading center`}>In Recognition</h6>
        <h2 className={`center`}>Awards & Recognition</h2>
        <div
          className={`flex`}
          style={{ width: "100%", flexWrap: "wrap", justifyContent: "center", marginTop: "60px" }}
        >
          {data.allContentfulAchievements.nodes.map((node)=>(
                    <AchievementsCard
                        image={node.thumbnail.file.url}
                        heading={node.name}
                        description={node.description.description}
                        year={node.year}
                    />
                )
            )}
        </div>
      </div>
    </section>
  </Layout>
    )
}

export default AchievementsPage